import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type {
  LC_ListMarksManagerIn,
  LC_ListMarksManagerOut,
  LC_RecalculateMarksManagerIn,
  LC_RecalculateMarksManagerOut,
  MarksManagerPage,
} from '../types';
import { mapMarksManagerPage } from '../mappers';
import type { GetEmployeesFilteredParams, FilteredEmployeesPage } from '@/api/domains/employee/types';
import { fetchFilteredEmployeesPage } from '@/api/domains/employee/services/employeeFiltered.service';


export class MarksManagerService {
  async list(
    params: LC_ListMarksManagerIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MarksManagerPage>> {
    const response = await apiClient.post<LC_ListMarksManagerOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE.MARKS_MANAGER_SEARCH,
      params,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMarksManagerPage(response.data) };
  }

  async recalculate(
    params: LC_RecalculateMarksManagerIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_RecalculateMarksManagerOut>> {
    return apiClient.post<LC_RecalculateMarksManagerOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE.MARKS_MANAGER_RECALCULATE,
      params,
      { signal },
    );
  }

  // ASIS-5572: mismo contrato de wire que employeeFilteredService.getFiltered (ver
  // fetchFilteredEmployeesPage), pero resuelto contra la sección GESTOR_MARCAS en el backend — el
  // combo "Colaborador" vive en esta pantalla, así que debe acotarse por el permiso que el usuario
  // tiene aquí, no por el que tenga (o no) en el módulo de Empleados. Ver
  // MarksManagerController.GetMarksManagerEmployeesAsync.
  async listEmployees(
    params: GetEmployeesFilteredParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<FilteredEmployeesPage>> {
    return fetchFilteredEmployeesPage(
      API_CONFIG.ENDPOINTS.ATTENDANCE.MARKS_MANAGER_EMPLOYEES,
      params,
      signal,
    );
  }
}

export const marksManagerService = new MarksManagerService();
